module.exports = __webpack_public_path__ + "img/background21.b9276201.jpg";